import { Injectable } from '@angular/core'
import { HttpErrorResponse } from '@angular/common/http'

@Injectable({
  providedIn: 'root',
})
export class DirectionService {
  direction: string = 'ltr'

  set(direction: 'rtl' | 'ltr') {
    this.direction = direction
  }
}
